import Input from '../input/Input'
import Select from './Select'
import InputRange from '../input/InputRange'
import { useMemo } from 'react'

export default function SelectUnits({ value, onChange, max = 8 }) {

    const options = useMemo(() =>  [...Array(max).keys()].map(i => ({ value: (i + 1).toString(), label: ((i + 1) * 40000).toLocaleString('he-IL') })), [max]);
    return (
        <>
            <div className="select-units desktop-flex-end">
                <Input type="number" className="child-units" name="child-units" label="שווי ביחידות"
                    tooltip="כל יחידה מזכה בהלוואה בסכום ₪40,000. ניתן לצרף עד 10 יחידות לכל ילד/ה." min="0" max={max}
                    value={value}
                    disabled={(Number(value) === 0)}
                    readOnly
                    tabIndex={-1}
                />
                <Select className="child-value" name="child-value" label='סכום ההלוואה בש"ח' value={value} onChange={onChange} readOnly  options={options}>
                    <option value="0" disabled hidden>בחר סכום</option>                    
                </Select>
            </div>
            <div className="fields-flex desktop-flex-end">
                <InputRange name="child-range-units" id="child-range-units" value={value} onChange={onChange} max={max} />
            </div>
        </>
    )
}
